import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import HomeApp from 'features/home/components/App';
import { Provider } from 'react-redux';
import Router from './Router';

import { store } from './redux/store';

const App: React.FC = () => (
  <Provider store={store}>
    <BrowserRouter>
      <HomeApp>
        <Router />
      </HomeApp>
    </BrowserRouter>
  </Provider>
);

export default App;
